import React from "react";
import "../../../../../Assets/Styles/ProfileContextMenu.scss";

const ProfileContextMenu = (props) => {
  return (
    <React.Fragment>
      <button
        onClick={() => props.setConfirmLogoutIsOpen(true)}
        className="logout-btn"
        id="logout-trigger"
      >
        <i className="feather-log-out"></i>
      </button>
    </React.Fragment>
  );
};

export default ProfileContextMenu;
